export default __webpack_public_path__ + "static/media/93.0dc2d0e9.gif";